import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem('token');

    if (token) {
      try {
        const decoded: any = jwtDecode(token);
        const dateNow = Math.floor(Date.now() / 1000);

        if (decoded.exp && decoded.exp < dateNow) {
          // Token is expired
          this.router.navigateByUrl('/login');
          return false;
        } else {
          // Token is valid
          return true;
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        this.router.navigateByUrl('/login');
        return false;
      }
    } else {
      // No token found
      this.router.navigateByUrl('/login');
      return false;
    }
  }
}
